/*
 * @Description: sentry 注册入口
 * @Date: 2021-11-23 09:48:36
 */

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { getStorage } from '@/tools/storage';
export default (Vue, Router) => {
  const sentry = Sentry;
  Sentry.init({
    Vue,
    dsn:
      window.location.protocol +
      '//95064aae7ea3495eab99ca394e3591ec@sentry.jimijiayuan.cn/2',
    release: process.env.VUE_APP_VERSION, // 版本
    environment: process.env.VUE_APP_SCENE, // 环境
    debugger: false,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(Router),
        tracingOrigins: ['localhost', 'my-site-url.com', /^\//]
      })
    ],
    initialScope: scope => {
      const userInfo = getStorage('user') || null;
      if (userInfo) {
        scope.setUser(userInfo);
      }

      return scope;
    },
    tracesSampleRate: 1.0
  });
  return sentry;
};
